/* -----------------Child components--------------- */
import { CustomAppbar } from "components/index";

/* -----------------Types--------------- */
import { ProfileContainer } from "@features/dashboard";
import useClerkUser from "@hooks/useClerkUser";
import { useDevice } from "@hooks/useDevice";
import DocumentTitle from "components/DocumentTitle";

const ProfileRoute = () => {
	const { username } = useClerkUser();

	const { isMobile } = useDevice();

	return (
		<>
			<CustomAppbar
				showCommandBar={false}
				showHambugerMenu
				back
				options={{
					headerTitle: username ?? "",
					subtitle: isMobile ? "" : "Your profile",
				}}
			/>
			<DocumentTitle title="Profile" />
			<ProfileContainer />
		</>
	);
};

export default ProfileRoute;
